import {
  REQUEST_PAY_INVOICE,
  REQUEST_PAY_INVOICE_ERROR,
  RECEIVE_PAY_INVOICE
} from 'actions'

export default (state = {}, action) => {
  switch (action.type) {
    case REQUEST_PAY_INVOICE:
      return {
        ...state,
        isRequesting: true,
        didRequestFail: false
      }
    case RECEIVE_PAY_INVOICE:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: false,
        data: action.payload.response
      }
    case REQUEST_PAY_INVOICE_ERROR:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: true,
        error: action.payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/invoice-payment.js